import * as React from 'react';
import styled from 'styled-components';

import t from '../../shared/translations';
import { IPage } from './CreateAccount';
import { IData } from './index';
import LoginForm from './LoginForm';
import { IAccountInvitation, IReusableAccountInvitation } from './queries';

interface IProps {
    data: IData;
    invitation: IReusableAccountInvitation | IAccountInvitation;
    teamScan: boolean | null;
    reusable: boolean;
    setPage: (page: IPage) => void;
}

const Main = styled.div`
    flex-grow: 1;
`;

const Space = styled.span`
    display: inline-block;
    width: 30px;
`;

function LoginPage({ data, setPage, invitation, teamScan, reusable }: IProps): JSX.Element {
    return <Main>
        <h1>{t('public.create-account-login.heading', { title: data.webappTitle })}</h1>
        {(invitation.learningPath || teamScan) && <>
            <div>
                {t('public.create-account-login.info-resource')}
            </div>
            <ul>
                {invitation.learningPath && <li>
                    {t('public.create-account-create.resource-path', { pathname: invitation.learningPath })}
                </li>}
                {teamScan && <li>
                    {t('public.create-account-create.resource-team-scan')}
                </li>}
            </ul>
        </>}
        <LoginForm data={data} reusable={reusable} />
        <div className='text-center'>
            <a href='/reset-password'>
                {t('public.create-account-login.link-forgot-password')}
            </a>
            <Space />
            <a href='#' onClick={e => {
                e.preventDefault();
                setPage('Create');
            }}>
                {t('public.create-account-login.link-create')}
            </a>
        </div>
    </Main>;
}

export default LoginPage;
